import { render, staticRenderFns } from "./select-regist.vue?vue&type=template&id=5069cdc8&scoped=true&"
import script from "./select-regist.vue?vue&type=script&lang=js&"
export * from "./select-regist.vue?vue&type=script&lang=js&"
import style0 from "./select-regist.vue?vue&type=style&index=0&id=5069cdc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5069cdc8",
  null
  
)

export default component.exports